module.exports = __webpack_public_path__ + "static/media/contacto.910c83b3.jpg";